

export default Policy

async function Policy(keys, checkType){
    let or = (checkType === 'or')
    let valid = (or) ? false : true

    _.map(keys, key => {
        if(!window.userRoles) return valid = false
        let roleToCheck = window.userRoles[key]
        if( or ){
            valid = (valid === true || roleToCheck) ? true : false
        }
        else{
            valid = (valid === true && roleToCheck) ? true : false
        }
    })
    return valid
}
